import {MainMenuModule} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuModule';
import {GameWinPresentationEvents} from 'src/winpresentation/GameWinPresentationEvents';
import {RespinEvents} from 'src/respin/RespinEvents';
import {GameAvalancheReelsEvents} from 'src/avalanche/GameAvalancheReelsEvents';
import {BigWinEvents} from '@fantasmagames/slot/src/modules/bigwin/BigWinEvents';

export class GameRecodeMainMenuModule extends MainMenuModule {

	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameWinPresentationEvents.COUNTING_STARTED, this.onWinCountingStarted);
		this.on(BigWinEvents.STARTED, this.onBigWinStarted);
		this.on(RespinEvents.RESPIN_STARTED, this.onRespinStarted);
		this.on(GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.onWinHighlightStarted);
	}

	protected onBigWinStarted(): void {
		this.hideMenu();
	}

	protected onWinCountingStarted(): void {
		this.hideMenu();
	}

	protected onRespinStarted(): void {
		this.hideMenu();
	}

	protected onWinHighlightStarted(): void {
		this.hideMenu();
	}
}



// WEBPACK FOOTER //
// ./src/mainmenu/GameRecodeMainMenuModule.ts